import React, { useEffect, useState } from 'react';
import { Styles } from './styles';
import { useNavigate } from 'react-router-dom';
import { usePropertyStore } from '@stores/Property/Property';
import { IProperty } from '@stores/Property/types';

const HilightAd: React.FC = () => {
  const navigate = useNavigate();
  const { fetchFeaturedProperties } = usePropertyStore();
  const [propertiesData, setPropertiesData] = useState<IProperty[]>([]);

  useEffect(() => {
    const loadFeaturedProperties = async () => {
      const featuredProperties = await fetchFeaturedProperties();
      setPropertiesData(featuredProperties);
    };
    loadFeaturedProperties();
  }, [fetchFeaturedProperties]);

  if (propertiesData.length === 0) {
    return null;
  }

  const latestProperty = propertiesData[0];

  return (
    <Styles.HighlightedAd
      onClick={() => navigate(`/imoveis/${latestProperty.id}`)}>
      <Styles.HighlightText>Destaques</Styles.HighlightText>
      <Styles.AdImage
        src={latestProperty.foto_capa}
        alt={latestProperty.titulo}
      />
      <Styles.AdTitle>{latestProperty.titulo}</Styles.AdTitle>
    </Styles.HighlightedAd>
  );
};

export default HilightAd;
